import React from 'react';

import { Text } from '../Text/Text';
import { WeatherConditionIcon } from '../Icons/WeatherIcons/WeatherCondition/WeatherConditionIcon';
import { IWeatherDailyData } from '../../helpers/hooks/fishingWater/useDailyWeatherForecast';
import { twMerge } from 'tailwind-merge';
import { ArrowDownIcon } from '../Icons/ArrowDownIcon';
import { ArrowUpIcon } from '../Icons/ArrowUpIcon';

interface IProps {
  className?: string;
  weatherData: IWeatherDailyData;
}

export const DailyWeatherCard = ({ className, weatherData }: IProps) => {
  const { airTempMin, airTempMax, conditionCode, dayOfWeek } = weatherData;

  return (
    <div
      className={twMerge(
        `bg-lake-fog flex flex-col justify-between gap-2 rounded-md p-4`,
        className,
      )}
    >
      <div>
        <Text variant="sm" className="text-abyss m-0 text-center font-semibold">
          {dayOfWeek}
        </Text>
      </div>
      <div className="flex flex-row justify-center">
        <WeatherConditionIcon conditionCode={conditionCode} height={50} width={50} />
        <div className="flex flex-col justify-around">
          <Text
            as="span"
            variant="sm"
            className="text-trench m-0 flex items-center gap-1 font-semibold"
          >
            <ArrowUpIcon size={16} className="my-auto" />
            {airTempMax}
          </Text>
          <Text
            as="span"
            variant="sm"
            className="text-midnight m-0 flex items-center gap-1 font-semibold"
          >
            <ArrowDownIcon size={16} className="text-midnight my-auto" />
            {airTempMin}
          </Text>
        </div>
      </div>
    </div>
  );
};
